// Data Fakultas
export const dataFakultas = [
    {
        fakultas_id: 1,
        fakultas_nama: "Fakultas Teknik",
        fakultas_kode: "FT",
        dekan_id: "DSN002",
        dekan_nama: "Prof. Dr. Ir. Hendro Wibowo, M.T.",
        status: 1,
        created_at: "2020-01-01"
    },
    {
        fakultas_id: 2,
        fakultas_nama: "Fakultas Ekonomi dan Bisnis",
        fakultas_kode: "FEB",
        dekan_id: "DSN010",
        dekan_nama: "Dr. Siti Rahayu, S.E., M.M.",
        status: 1,
        created_at: "2020-01-01"
    },
    {
        fakultas_id: 3,
        fakultas_nama: "Fakultas Ilmu Komputer",
        fakultas_kode: "FILKOM",
        dekan_id: "DSN015",
        dekan_nama: "Dr. Agus Prasetyo, S.Kom., M.Cs.",
        status: 1,
        created_at: "2020-01-01"
    }
];

export const listDekan = [
    { value: "DSN002", label: "Prof. Dr. Ir. Hendro Wibowo, M.T." },
    { value: "DSN010", label: "Dr. Siti Rahayu, S.E., M.M." },
    { value: "DSN015", label: "Dr. Agus Prasetyo, S.Kom., M.Cs." },
    { value: "DSN020", label: "Dr. Maya Indah, S.H., M.H." }
];

export default dataFakultas;
